import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DatePicker } from 'antd';
import dayjs from 'dayjs';
const CustomDatePicker = ({ value, onChange, ...rest }) => {
    const handleChange = (date) => {
        onChange?.(date ? date.toISOString() : undefined);
    };
    const val = value ? dayjs(value) : undefined;
    return _jsx(DatePicker, { ...rest, value: val, onChange: handleChange, style: { width: '100%' } });
};
export default React.memo(CustomDatePicker);
